import { ChangeDetectorRef, ElementRef, EventEmitter, input, output, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AudioRecordingService, } from 'Angular/services/audio-recording.service';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { IconModule } from '../../directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/urls.service";
import * as i2 from "Angular/services/core/ajax.service";
import * as i3 from "Angular/services/audio-recording.service";
import * as i4 from "../../directives/icon/icon.directive";
import * as i5 from "../../directives/popovers/tooltip/tooltip.directive";
const _c0 = ["voiceCanvas"];
function AudioTranscriptionInputComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "canvas", 3, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "button", 5);
    i0.ɵɵlistener("click", function AudioTranscriptionInputComponent_Conditional_1_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancelTranscription()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "button", 7);
    i0.ɵɵlistener("click", function AudioTranscriptionInputComponent_Conditional_1_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.stopTranscription()); });
    i0.ɵɵtext(7, "Done");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("width", ctx_r1.maxCanvasWidth());
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-close");
} }
function AudioTranscriptionInputComponent_Conditional_2_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 8);
    i0.ɵɵelement(2, "span", 9);
    i0.ɵɵelementEnd()();
} }
function AudioTranscriptionInputComponent_Conditional_2_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 10);
    i0.ɵɵlistener("input", function AudioTranscriptionInputComponent_Conditional_2_Conditional_1_Template_input_input_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onInputChange($event)); })("keydown.enter", function AudioTranscriptionInputComponent_Conditional_2_Conditional_1_Template_input_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onEnterPressed()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "div", 11)(2, "span", 5);
    i0.ɵɵlistener("click", function AudioTranscriptionInputComponent_Conditional_2_Conditional_1_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.startTranscription()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵinterpolate(ctx_r1.placeholder))("value", ctx_r1.inputText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-microphone")("tooltipTitle", "Dictation")("tooltipIgnoreViewport", true)("tooltipPlacement", "top");
} }
function AudioTranscriptionInputComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AudioTranscriptionInputComponent_Conditional_2_Conditional_0_Template, 3, 0, "div", 2)(1, AudioTranscriptionInputComponent_Conditional_2_Conditional_1_Template, 4, 7);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.processing || ctx_r1.settingUpTranscription ? 0 : 1);
} }
/**
 * AudioTranscriptionInputComponent component
 *
 * This component displays a text input with controls to start an audio transcription session. During transcription
 * it will display a canvas with mic activity (voice volume) and when done, it will send the audio to
 * AITranscription Django view to generate a transcription. The transcription will be displayed in the input.
 */
export class AudioTranscriptionInputComponent {
    constructor(cdRef, urlsService, ajaxService, audioRecordingService) {
        this.cdRef = cdRef;
        this.urlsService = urlsService;
        this.ajaxService = ajaxService;
        this.audioRecordingService = audioRecordingService;
        this.transcribedText = new EventEmitter();
        this.transcriptionError = new EventEmitter();
        this.transcriptionCancel = output();
        this.transcriptionStop = output();
        this.placeholder = '';
        this.inputText = '';
        this.maxCanvasWidth = input(468, ...(ngDevMode ? [{ debugName: "maxCanvasWidth" }] : []));
        // Flags
        this.transcribing = false;
        this.processing = false;
        this.settingUpTranscription = false;
        this.voiceActivityHistory = [];
        this.maxHistory = 468;
        this.currentVolume = 0;
        this.strokeWidth = 1.5; // Width of each stroke
        this.strokeSpacing = 1.5; // White space between strokes
        this.strokeColor = '#0282e8';
        this.canvasWidth = 0;
        this.canvasHeight = 0;
    }
    ngOnDestroy() {
        if (this.audioRecordingSubscription) {
            this.audioRecordingSubscription.unsubscribe();
        }
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }
    }
    /**
     * Set up the canvas size where the voice activity is going to be displayed
     * @private
     */
    setupCanvas() {
        this.canvas = this.canvasRef.nativeElement;
        this.canvasCtx = this.canvas.getContext('2d') || undefined;
        if (this.canvas && this.canvasCtx) {
            // Set canvas size
            const rect = this.canvas.getBoundingClientRect();
            // Every screen has different physical pixel numbers per CSS pixels. So the size of the canvas
            // depends on the device screen settings.
            const devicePixelRatio = window.devicePixelRatio || 1;
            this.canvas.width = rect.width * devicePixelRatio;
            this.canvas.height = rect.height * devicePixelRatio;
            this.canvasCtx.scale(devicePixelRatio, devicePixelRatio);
            this.canvas.style.width = `${rect.width}px`;
            this.canvas.style.height = `${rect.height}px`;
            this.canvasWidth = rect.width;
            this.canvasHeight = rect.height;
            this.maxHistory = Math.floor(rect.width / (this.strokeWidth + this.strokeSpacing));
        }
    }
    /**
     * Starts the voice activity visualization. It will create the canvas, add dots and then start the animation,
     * which will depend on the history of voice activites recored.
     * @private
     */
    startVisualization() {
        if (this.canvasRef) {
            this.setupCanvas();
        }
        if (!this.canvas || !this.canvasCtx)
            return;
        this.voiceActivityHistory = [];
        // Clear canvas with white background initially
        this.clearCanvas();
        this.animate();
    }
    /**
     * Stops the canvas animation and clears the canvas
     * @private
     */
    stopVisualization() {
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
            this.animationId = undefined;
        }
        this.clearCanvas();
    }
    /**
     * Main method for the animation. It will call `redrawWaveform` if there new voic activity values in
     * `voicAcvitivyHistory`. If the activity already filled the canvas, it will shift the data to make room
     * for new activity values.
     * @private`
     */
    animate() {
        if (!this.transcribing || !this.canvas || !this.canvasCtx)
            return;
        // Check if we have new volume data to add
        const hasNewData = this.voiceActivityHistory.length === 0 ||
            this.voiceActivityHistory[this.voiceActivityHistory.length - 1] !== this.currentVolume;
        if (hasNewData) {
            // Add new volume data to the end
            this.voiceActivityHistory.push(this.currentVolume);
            // Remove old data if we have too much
            if (this.voiceActivityHistory.length > this.maxHistory) {
                this.voiceActivityHistory.shift();
            }
            // Redraw the entire waveform
            this.redrawWaveform();
        }
        this.animationId = requestAnimationFrame(() => this.animate());
    }
    /**
     * Draws the background dots displayed when the canvas is emtpy.
     * @private
     */
    drawBackgroundDots() {
        if (!this.canvas || !this.canvasCtx)
            return;
        const centerY = this.canvasHeight / 2;
        // Draw light gray dots across the entire canvas
        this.canvasCtx.fillStyle = '#ccc';
        for (let x = 0; x < this.canvasWidth; x += this.strokeWidth + this.strokeSpacing) {
            // Draw a small dot at the center line
            this.canvasCtx.fillRect(x, centerY - 0.5, this.strokeWidth, 1);
        }
    }
    /**
     * Draws the waveform with the current values in `voicAcvitivyHistory`
     * @private
     */
    redrawWaveform() {
        if (!this.canvas || !this.canvasCtx)
            return;
        const centerY = this.canvasHeight / 2;
        const maxBarHeight = this.canvasHeight - 2;
        // Clear canvas with white background
        this.canvasCtx.fillStyle = '#ffffff';
        this.canvasCtx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
        // Draw background dots if the canvas is not full yet
        if (this.voiceActivityHistory.length < this.maxHistory) {
            this.drawBackgroundDots();
        }
        // Calculate the starting position (right-aligned)
        const totalWidth = this.voiceActivityHistory.length * (this.strokeWidth + this.strokeSpacing) - this.strokeSpacing;
        let startX = this.canvasWidth - totalWidth;
        // If we have more data than can fit, start from the left edge
        if (startX < 0) {
            startX = 0;
        }
        // Draw each stroke from left to right (oldest to newest)
        this.canvasCtx.strokeStyle = this.strokeColor;
        this.canvasCtx.lineWidth = this.strokeWidth;
        for (let i = 0; i < this.voiceActivityHistory.length; i += 1) {
            const x = startX + i * (this.strokeWidth + this.strokeSpacing);
            // Only draw if the stroke is within the canvas bounds
            if (x >= 0 && x + this.strokeWidth <= this.canvasWidth) {
                const volume = this.voiceActivityHistory[i];
                // Calculate stroke height based on the volume and the maxBarHeight
                let barHeight = Math.max(1, Math.round(volume * maxBarHeight));
                barHeight = Math.min(barHeight, maxBarHeight);
                // Draw the stroke
                this.canvasCtx.beginPath();
                this.canvasCtx.moveTo(x, centerY - barHeight / 2);
                this.canvasCtx.lineTo(x, centerY + barHeight / 2);
                this.canvasCtx.stroke();
            }
        }
    }
    /**
     * Clear the canvas with a white rectangle
     * @private
     */
    clearCanvas() {
        if (this.canvas && this.canvasCtx) {
            // Clear with white background
            this.canvasCtx.fillStyle = '#ffffff';
            this.canvasCtx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
            // Draw background dots when canvas is empty
            this.drawBackgroundDots();
        }
        this.voiceActivityHistory = [];
    }
    /**
     * Cancel the transcription and don't trigger a service call by unsubscribing from the audio recording.
     */
    cancelTranscription() {
        if (this.audioRecordingSubscription) {
            this.audioRecordingSubscription.unsubscribe();
            this.audioRecordingSubscription = undefined;
        }
        if (this.transcribing) {
            this.audioRecordingService.stop();
        }
        this.transcriptionCancel.emit();
        this.transcribing = false;
    }
    /**
     * Stop the transcription. It will trigger a RECORDING_STOP event that will result in the audio being transcribed
     * by the service.
     */
    stopTranscription() {
        if (this.transcribing) {
            this.transcriptionStop.emit();
            this.audioRecordingService.stop();
        }
    }
    /**
     * Starts a transcription. Subscribes to AudioRecordingService.
     * @protected
     */
    async startTranscription() {
        if (!this.transcribing) {
            this.settingUpTranscription = true;
            this.audioRecordingSubscription = this.audioRecordingService
                .getRecordingEvent()
                .subscribe((event) => this.handlerNewTranscriptionServiceEvent(event));
            await this.audioRecordingService.start();
        }
    }
    // Handlers
    /**
     * Handles events from AudioRecordingService.
     * @param event
     */
    handlerNewTranscriptionServiceEvent(event) {
        switch (event.event) {
            case 'FREQUENCY_DATA':
                this.currentVolume = event.volume || 0;
                break;
            case 'RECORDING_STARTED':
                this.transcribing = true;
                this.settingUpTranscription = false;
                this.cdRef.detectChanges();
                this.startVisualization();
                break;
            case 'AUDIO_READY':
                this.processing = true;
                const base64Audio = event.audioData?.blob;
                if (base64Audio) {
                    const formData = new FormData();
                    formData.append('audio', base64Audio, 'audio.mp4');
                    this.ajaxService
                        .postDataObserveBody(this.urlsService.SYSTEMS.AI_AUDIO_TRANSCRIPTION, formData)
                        .subscribe({
                        next: (data) => {
                            this.inputText = data.transcription;
                            this.transcribedText.emit(this.inputText);
                            this.processing = false;
                            this.cdRef.detectChanges();
                        },
                        error: () => {
                            this.processing = false;
                        },
                    });
                }
                this.transcribing = false;
                this.stopVisualization();
                if (this.audioRecordingSubscription) {
                    this.audioRecordingSubscription.unsubscribe();
                    this.audioRecordingSubscription = undefined;
                }
                break;
            case 'RECORDING_STOPPED':
                break;
            case 'ERROR':
                this.transcriptionError.emit(event.error);
                this.transcribing = false;
                this.processing = false;
                this.settingUpTranscription = false;
                this.stopVisualization();
                if (this.audioRecordingSubscription) {
                    this.audioRecordingSubscription.unsubscribe();
                    this.audioRecordingSubscription = undefined;
                }
                this.cdRef.detectChanges();
                break;
            default:
                break;
        }
        this.cdRef.detectChanges();
    }
    onInputChange(event) {
        this.inputText = event.target.value;
        this.transcribedText.emit(this.inputText);
    }
    onEnterPressed() {
        if (this.inputText) {
            this.transcribedText.emit(this.inputText);
        }
    }
}
AudioTranscriptionInputComponent.ɵfac = function AudioTranscriptionInputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AudioTranscriptionInputComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.AjaxService), i0.ɵɵdirectiveInject(i3.AudioRecordingService)); };
AudioTranscriptionInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AudioTranscriptionInputComponent, selectors: [["ycn-audio-transcription-input"]], viewQuery: function AudioTranscriptionInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.canvasRef = _t.first);
    } }, inputs: { placeholder: "placeholder", inputText: "inputText", maxCanvasWidth: [1, "maxCanvasWidth"] }, outputs: { transcribedText: "transcribedText", transcriptionError: "transcriptionError", transcriptionCancel: "transcriptionCancel", transcriptionStop: "transcriptionStop" }, decls: 3, vars: 1, consts: [["voiceCanvas", ""], [1, "field-input-group", "input-group"], [1, "form-audio-preview", "form-control", "form-control-md", "is-focused"], ["height", "21", 1, "voice-visualizer", 3, "width"], [1, "field-input-group-actions", "align-items-center", "d-flex", "height-full", "mr-12"], [1, "btn", "btn-circle", "btn-transparent2", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "btn", "btn-transparent2", 3, "click"], [1, "ng-binding"], [1, "loader-dots"], ["type", "text", 1, "form-control", "field-input", "ng-pristine", "ng-valid", "ng-empty", "ng-touched", 3, "input", "keydown.enter", "value", "placeholder"], [1, "field-input-group-actions"], ["ycnIcon", "", "ycnTooltip", "", 3, "name", "tooltipTitle", "tooltipIgnoreViewport", "tooltipPlacement"]], template: function AudioTranscriptionInputComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1);
        i0.ɵɵconditionalCreate(1, AudioTranscriptionInputComponent_Conditional_1_Template, 8, 2)(2, AudioTranscriptionInputComponent_Conditional_2_Template, 2, 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.transcribing ? 1 : 2);
    } }, dependencies: [IconModule, i4.IconDirective, FormsModule, TooltipModule, i5.TooltipDirective], encapsulation: 2 });
